import React, { useState, useEffect } from 'react'
import { Button, Grid, Chip, Stack } from '@mui/material'
import {
  generateAcervoReport,
  acervoReportXls
} from '../dashboard/functions/generateReport'
import { AdaptativeGridContainer, DefaultPainel } from '../../components/shared'
import { Obras } from '../../services/http'
import { StyledDatagridAcervo } from './components'
import TableHeader from '../../components/shared/tables/TableHeader'
import gerarPaginacao from '../../services/pagination'
import { object, string } from 'prop-types'
import formatFilter from './functions'
import getAutoresNomes from '../postagens/functions/getAutoresNomes'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const RelatorioAcervo = ({ filter, libName }) => {
  const [rows, setRows] = useState([])
  const [query, setQuery] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [lastPage, setLastPage] = useState(1)
  // const [nomeBiblioteca, setNomeBiblioteca] = useState('')

  const tableRelations = {
    'includes[exemplares][biblioteca_id]': 'biblioteca',
    'count[exemplares][biblioteca_id]': 'biblioteca',
    ano: 'ano',
    'includes[exemplares][formato_exemplar_id]': 'formato'
  }

  function countExemplares(ex) {
    const formats = []
    const AuxFormats = []
    ex?.forEach(element => {
      if (AuxFormats.indexOf(element.formato_exemplar_id) === -1) {
        formats.push(element.formato_exemplar)
        AuxFormats.push(element.formato_exemplar_id)
      }
    })
    return formats
  }

  const getObras = async (filters = {}, page = 1) => {
    const { data } = await Obras().show({
      ...filters,
      includes: [
        'obraAutores.autor',
        'categoriaObra',
        'editora',
        'exemplares.formatoExemplar'
      ],
      page
    })

    const aux = data.data.map(item => {
      return {
        ...item,
        autor: getAutoresNomes(item.obra_autores),
        categoria: item.categoria_obra.descricao,
        editora: item.editora.nome,
        tiposExemplares: countExemplares(item.exemplares)
      }
    })
    // console.log(aux)
    setCurrentPage(data.current_page)
    setLastPage(data.last_page)
    setRows(aux)
  }

  const columns = [
    {
      field: 'titulo',
      headerName: 'Obra',
      flex: 3,
      align: 'left'
    },
    {
      field: 'autor',
      headerName: 'Autor',
      flex: 3,
      align: 'left'
    },
    {
      field: 'categoria',
      headerName: 'Categoria',
      flex: 3,
      align: 'left'
    },
    // {
    //   field: 'editora',
    //   headerName: 'Editora',
    //   flex: 2,
    //   align: 'left'
    // },
    {
      field: 'numero_pagina',
      headerName: 'Pág',
      flex: 1,
      align: 'left'
    },

    {
      field: 'tiposExemplares',
      headerName: 'Formato',
      flex: 2.5,
      align: 'left',
      renderCell: ({ row }) => {
        return (
          <Stack sx={{ width: '100%' }} direction="row" spacing={0.3}>
            {row.tiposExemplares.map((item, i) => {
              return <Chip variant="outlined" label={item.descricao} key={i} />
            })}
          </Stack>
        )
      }
    }
    // {
    //   field: 'exemplares_count',
    //   headerName: 'Exemplares',
    //   flex: 2,
    //   align: 'center'
    // }
  ].map(item => {
    return {
      ...item,
      headerClassName: 'styledHeader',
      sortable: false
    }
  })

  useEffect(() => {
    setQuery(Object.assign(query, { ...filter }))
    getObras(formatFilter(filter, tableRelations))
  }, [filter])

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getObras(formatFilter(filter, tableRelations), value)
  )

  return (
    <>
      <DefaultPainel sx={{ mt: '4vh', p: 2 }}>
        <AdaptativeGridContainer>
          <>
            <Grid item xs={12} sm={12}>
              <TableHeader
                titulo={`Acervo de Obras - ${libName || ''}`}
                controls={
                  <MobileFilterHeaderContainer>
                    <Button
                      color="white"
                      onClick={() =>
                        acervoReportXls({
                          ano: query.ano,
                          biblioteca: query.biblioteca,
                          formato: query?.formato
                        })
                      }
                    >
                      Ver relatório em XSL
                    </Button>
                    <Button
                      color="white"
                      onClick={() =>
                        generateAcervoReport({
                          ano: query.ano,
                          biblioteca: query.biblioteca,
                          formato: query?.formato
                        })
                      }
                    >
                      Ver relatório em PDF
                    </Button>
                  </MobileFilterHeaderContainer>
                }
              />
              <StyledDatagridAcervo
                columns={columns}
                rows={rows}
                rowsPerPageOptions={[10]}
                disableColumnMenu
                disableColumnSelector
                pagination={pagination}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </>
  )
}

RelatorioAcervo.propTypes = {
  filter: object,
  libName: string,
  formatos: object
}

export default RelatorioAcervo
